import { render, staticRenderFns } from "./AllSettings.vue?vue&type=template&id=8757e8ac&"
import script from "./AllSettings.vue?vue&type=script&lang=js&"
export * from "./AllSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports